import mdmActionTypes from "../actions/mdmActionTypes";
import { reducerFactory } from "../../common/redux/reducers/reducerFactory";

export const mdmReducer = reducerFactory.readReducer(
  mdmActionTypes
);
